import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, TextField, Typography } from "@mui/material";

export default function MessageDialog(props) {

	const [state, setState] = useState({});
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setState({
			...state,
			updated: true,
			[event.target.name]: event.target.value,
		});
	};
	const handleSendMessage = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(state),
		};
		fetch("/api/308a17e15c6c432681daefe51af4cddb/" + props.state.params.u, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Message privé à {props.state.params.hd}
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<TextField
					id="subject"
					name="subject"
					variant="outlined"
					style={{
						marginLeft: 0,
						marginRight: 10,
					}}
					placeholder="Sujet"
					fullWidth
					size="small"
					margin="dense"
					value={state.subject || props.header || ""}
					onChange={handleChange}
				/>
				<TextField
					id="content"
					name="content"
					variant="outlined"
					style={{
						marginLeft: 0,
						marginRight: 10,
					}}
					placeholder="Contenu"
					fullWidth
					multiline
					rows={5}
					margin="dense"
					value={state.content}
					onChange={handleChange}
				/>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="space-between" style="width: 100%">
					<Box>
						<Button onClick={handleClose}>Annuler</Button>
					</Box>
					<Box>
						<Button variant="contained" onClick={handleSendMessage} disabled={state.subject === undefined || state.content === undefined}>
							Envoyer
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
